import { ModalExcluirState } from './types';
import ModalDefault from '../../../../../ModalDefault';
import { SaveButton, CancelButton } from './styles';

interface ModalExcluirProps {
    modal: ModalExcluirState;
    onConfirmar: () => void;
    onCancelar: () => void;
}

export default function ModalExcluir({ modal, onConfirmar, onCancelar }: ModalExcluirProps) {
    return (
        <ModalDefault
            id="modal-excluir-parte"
            openModal={modal.aberto}
            onClose={onCancelar}
        >
            <div style={{ padding: '20px' }}>
                <h3 style={{ marginBottom: '16px' }}>Confirmar Exclusão</h3>
                <p style={{ marginBottom: '20px' }}>
                    Tem certeza que deseja excluir a parte "{modal.nome}"?
                </p>
                <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
                    <CancelButton onClick={onCancelar}>
                        Cancelar
                    </CancelButton>
                    <SaveButton
                        onClick={onConfirmar}
                        style={{ backgroundColor: 'var(--ce53e3e)' }}
                    >
                        Excluir
                    </SaveButton>
                </div>
            </div>
        </ModalDefault>
    );
}

